module.exports = {
  CLASS_GROUP_SECTION: '1',
  TEST_BEHAVIOR_SECTION: '2',
  ANTI_CHEATING_SECTION: '3',
  AUTO_REDIRECT_SECTION: '4',
  MASTERY_BANDS_SECTION: '5',
  SECTIONS_SETTINGS_SECTION: '6',
  ACCOMMODATIONS_SECTION: '7',
}
